import {
  ADD_MESSAGE,
  CREATE_MESSAGE,
  CREATE_MESSAGE_FAIL,
  CreateMessageActionType,
  FETCH_CONVERSATION_SUCCESS
} from 'dealer-reducers'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { POST } from '../consts/methods'

import { Message } from 'dealer-types'
import { type ApiCallParams } from '../helpers/apiCall'
import { RootReducer } from 'src/redux/rootReducer'
interface CreateMessageResponse extends Message {}
export const CreateMessageSaga = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  apiCall: (params: ApiCallParams<any>) => Promise<any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Generator<any, void, any> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function* CreateMessageFlow(action: CreateMessageActionType): Generator<any, void, any> {
    try {
      const endpoint = '/api/v2/messages'
      const response: CreateMessageResponse = yield call(apiCall, {
        endpoint,
        method: POST,
        params: {
          offer: { hash_id: action.payload.offer_hash_id },
          message: { body: action.payload.body }
        }
      })
      const conversationReducer = yield select((state: RootReducer) => state.conversationReducer)

      if (conversationReducer.id !== response.conversation_id) {
        yield put(
          FETCH_CONVERSATION_SUCCESS({
            ...conversationReducer,
            id: response.conversation_id,
            offer_hash_id: action.payload.offer_hash_id,
            messages: []
          })
        )
      }
      yield put(ADD_MESSAGE(response))
    } catch (error) {
      yield put(CREATE_MESSAGE_FAIL())
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function* CreateConversation(): Generator<any, void, any> {
    yield takeLatest(CREATE_MESSAGE, CreateMessageFlow)
  }

  return CreateConversation()
}
